var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 25V10.5078L6.64062 15.1953L4.96094 13.5156L12.5 5.97656L20.0391 13.5156L18.3594 15.1953L13.6719 10.5078V25H11.3281ZM0 7.92969V2.34375C0 1.71875 0.234375 1.17188 0.703125 0.703125C1.17188 0.234375 1.71875 0 2.34375 0H22.6562C23.2812 0 23.8281 0.234375 24.2969 0.703125C24.7656 1.17188 25 1.71875 25 2.34375V7.92969H22.6562V2.34375H2.34375V7.92969H0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1ff8d841b67c4e7e525b020010cee0b1.svg";
export { ForwardRef as ReactComponent };